import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentWaybillEquipmentsFacade } from './shipment-waybill-equipments.facade';
import { switchMap, take } from 'rxjs/operators';
import { WaybillIdView } from '../../../../models';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillEquipmentsGuard {
  constructor(
    private shipmentWaybillItemFacade: ShipmentWaybillItemFacade,
    private shipmentWaybillEquipmentsFacade: ShipmentWaybillEquipmentsFacade,
  ) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$.pipe(
      take(1),
      switchMap((identifier: WaybillIdView) => {
        return loadStoreState(this.shipmentWaybillEquipmentsFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillEquipmentsFacade);
  }
}
